export const parsePriceValue = (value) => {
    return value.split('..').map((v) => Number(v.replace(/[^0-9.]/g, '')))
}
